import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CKEditorModule } from 'ckeditor4-angular';
import { SharedModule } from '../../shared/shared.module';

import { Constants } from '../../shared/common/helper/constants';
import { WelcomeLayoutComponent } from './welcome/welcome-layout.component';
import { PcnBlockComponent } from '../../shared/common/components/pcn-block/pcn-block.component';
import { PcnConfirmationModalComponent } from '../../shared/common/components/pcn-confirmation-modal/pcn-confirmation-modal.component';
import { LetterDashboardComponent } from '../../shared/common/components/letter-dashboard/letter-dashboard.component';
import { WelcomeComponent } from '../../shared/common/components/welcome/welcome.component';
import { ReasonsLayoutComponent } from './reasons/reasons-layout.component';
import { ReasonsComponent } from '../../shared/common/components/reasons/reasons.component';
import { DocumentsQuestionsComponent } from '../../shared/common/components/documents-questions/documents-questions.component';
import { NexusUploadComponent } from '../../shared/common/components/nexus-upload/nexus-upload.component';
import { QuestionComponent } from '../../shared/common/components/documents-questions/question/question.component';
import { LetterComponent } from '../../shared/common/components/letter/letter.component';
import { ChangeDecisionComponent } from '../../shared/common/components/change-decision/change-decision.component';
import { BespokeLetterComponent } from '../../shared/common/components/bespoke-letter/bespoke-letter.component';
import { CustomLettersComponent } from '../../shared/common/components/custom-letters/custom-letters.component';
import { CustomParagraphsComponent } from '../../shared/common/components/custom-paragraphs/custom-paragraphs.component';
import { HelpComponent } from '../../shared/common/components/help/help.component';
import { TermsComponent } from '../../shared/common/components/terms/terms.component';

import { NgCircleProgressModule } from 'ng-circle-progress';
import { PcnGuard } from '../../shared/common/services/pcn-guard.service';
import { QuestionsConst } from '../../shared/common/helper/questionConst';
import { DecisionsConst } from '../../shared/common/helper/decisionsConst';
import { PcnConst } from '../../shared/common/helper/pcnConst';
import { LetterManagementComponent } from '../../shared/common/components/letter-management/letter-management.component';

/* Kendo Imports */
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import { UploadModule } from '@progress/kendo-angular-upload';
import { UserSettingsComponent } from '../../shared/common/components/user-settings/user-settings.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    NgCircleProgressModule.forRoot(),
    NgbModule,
    CKEditorModule,
    GridModule,
    ButtonsModule,
    DialogModule,
    WindowModule,
    LabelModule,
    InputsModule,
    DropDownsModule,
    DateInputsModule,
    CheckBoxModule,
    UploadModule,
  ],
  declarations: [
    WelcomeLayoutComponent,
    WelcomeComponent,
    PcnBlockComponent,
    PcnConfirmationModalComponent,
    LetterDashboardComponent,
    ReasonsLayoutComponent,
    UserSettingsComponent,
    ReasonsComponent,
    NexusUploadComponent,
    QuestionComponent,
    DocumentsQuestionsComponent,
    LetterComponent,
    ChangeDecisionComponent,
    BespokeLetterComponent,
    CustomLettersComponent,
    CustomParagraphsComponent,
    HelpComponent,
    TermsComponent,
    LetterManagementComponent,
  ],
  providers: [QuestionsConst, DecisionsConst, PcnConst, Constants, PcnGuard],
})
export class ApplicationModule {}
